export const GET_CHOIR = "choir/GET_CHOIR";
export const GET_CHOIR_ERROR = "choir/GET_CHOIR_ERROR";
